import React from 'react';
import SummaryCard from '../shared/SummaryCard';

const FilesSection = ({ filesData, onViewDetails }) => {
    if (!filesData || !filesData.files || filesData.files.length === 0) {
        return null;
    }

    const { total_files, total_unique_files, files, file_category_stats } = filesData;

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px'
            }}>
                <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>Files</h4>
                <button
                    onClick={onViewDetails}
                    style={{
                        backgroundColor: '#3a3a3a',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '8px 14px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: '600'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#4a4a4a'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#3a3a3a'}
                >
                    View file details
                </button>
            </div>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '20px'
            }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                    gap: '15px'
                }}>
                    <SummaryCard label="Total Files" value={total_files ?? 0} />
                    <SummaryCard label="Unique Files" value={total_unique_files ?? files.length} />
                </div>
                {file_category_stats && Object.keys(file_category_stats).length > 0 && (
                    <div style={{ marginTop: '20px' }}>
                        <div style={{
                            fontSize: '12px',
                            color: '#9a9a9a',
                            textTransform: 'uppercase',
                            marginBottom: '12px',
                            fontWeight: '600',
                            letterSpacing: '0.5px'
                        }}>
                            File Categories
                        </div>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '8px'
                        }}>
                            {Object.entries(file_category_stats).map(([category, count]) => (
                                <span
                                    key={category}
                                    style={{
                                        display: 'inline-block',
                                        backgroundColor: '#1e3a5f',
                                        color: '#60a5fa',
                                        padding: '6px 12px',
                                        borderRadius: '12px',
                                        fontSize: '12px',
                                        fontWeight: '500'
                                    }}
                                >
                                    {category}: {count}
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FilesSection;

